import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UtilService } from '@com-delta-idp/mnx-oauth';
import { RETRY_COUNT } from '@com-delta-idp/mnx-trip-management-shared-smart';
import { TravelReservation } from '@com-delta-idp/mnx-trip-management-shared-ui';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import {
  EndpointKeys,
  HTTP_HEADERS,
  IDP_APP,
  TRIP_USING
} from '../models/constants/search-config.constant';
import {
  CreditRequest,
  TripsRequest
} from '../models/interface/request.interface';
@Injectable({
  providedIn: 'root'
})
export class CreditCardSearchService {
  travelResRetryCount = 0;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {
    this.appConfig
      .getConfigValue(IDP_APP, RETRY_COUNT.TRAV_RES)
      .subscribe((value: string) => {
        const configValue = Number(value);
        if (!isNaN(configValue) && configValue >= 0) {
          this.travelResRetryCount = Math.min(
            configValue,
            RETRY_COUNT.MAX_VALUE
          );
        }
      });
  }

  errorHandler = handleError.bind(this);

  getPNRList = (request: CreditRequest): Observable<TravelReservation> => {
    return new ApiBuilder<TripsRequest, TravelReservation>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP)
      .endpointKey(EndpointKeys.TRAVEL_RESERVATION)
      .method(HttpRequestMethods.POST)
      .retries(this.travelResRetryCount)
      .payload({
        using: TRIP_USING.CREDITCARD,
        creditCardNum: request.referenceId,
        givenNames: request.fName,
        surname: request.lName
      })
      .httpHeaders({
        'Content-Type': HTTP_HEADERS.CONTENT_TYPE,
        appId: HTTP_HEADERS.APP_ID,
        channelId: HTTP_HEADERS.MY_TRIP,
        transactionid: `${HTTP_HEADERS.PREFIX}-${
          request.app
        }-${this.utils.generateUniqueIdentifier()}`
      })
      .errorHandler(this.errorHandler)
      .create();
  };
}
